
import "vue-range-component-fixed/dist/vue-range-slider.css";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
  name: "FormSlider",

  data: function () {
    const currencyMask = function (rawValue) {
      let numberMask = createNumberMask({
        prefix: "",
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: '.',
        thousandsSeparatorSymbol: "",
        decimalLimit: 2
      });
      rawValue = rawValue.replace(',','.');
      let mask = numberMask(rawValue);
      return mask
    };

    return {
      newValue: this.value || this.min,
      newValueRange: this.value || this.min,

      currencyMask
    }
  },

  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },

    min: {
      type: [Number, String],
      default: ""
    },
    max: {
      type: [Number, String],
      default: ""
    },
    step: {
      type: [Number, String],
      default: "1"
    },
  },

  watch: {
    value: function () {
      this.newValue = this.value ||  this.min || '';
      this.newValueRange = this.value ||  this.min || '';
    },
    newValue: function (current, prev) {
      if (current == prev) {
        return
      }
      if (!prev && current == this.min) {
        return;
      }

      this.$emit("input", current);
    },
    newValueRange: function (current, prev) {
      if (current == prev) {
        return
      }
      if (!prev && current == this.min) {
        return;
      }
      this.$emit("input", current);
    },
  },

  methods: {
    onFocusInput: function () {
      this.newValue = "";
    },
    onBlurInput: function () {
      this.newValue = this.value || this.min;
    },
  }
}
